import { render, staticRenderFns } from "./RtoFbx.vue?vue&type=template&id=4ad644fa&scoped=true"
import script from "./RtoFbx.vue?vue&type=script&lang=js"
export * from "./RtoFbx.vue?vue&type=script&lang=js"
import style0 from "./RtoFbx.vue?vue&type=style&index=0&id=4ad644fa&prod&scoped=true&lang=css"
import style1 from "./RtoFbx.vue?vue&type=style&index=1&id=4ad644fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad644fa",
  null
  
)

export default component.exports